import { configureApiEntity } from '../adapter/index';
import { schema } from 'normalizr';

export const orderSchema = new schema.Entity('orders');

export const orders = configureApiEntity('ORDERS', 'orders', orderSchema);
